<template>
    <div>
        <b-modal
            :visible="value"
            :id="modal_id"
            size="lg"
            @cancel="close"
            @close="close"
            @hidden="hidden"
        >

            <template #modal-title>
                Settings
            </template>

            <b-tabs content-class="my-3">
                <b-tab title="General" active>
                    <div>
                        <b-form-group label="WYSIWYG Menu Type">
                            <b-form-radio v-model="wysiwyg_menu_type" value="bubble">Floating</b-form-radio>
                            <b-form-radio v-model="wysiwyg_menu_type" value="menu_bar">Menu Bar</b-form-radio>
                        </b-form-group>
                    </div>
                </b-tab>
                <b-tab title="Articles">
                    <b-form-checkbox v-model="edit_lexile_certified_score" switch>
                        Lexile Certified Score Editable
                    </b-form-checkbox>
                </b-tab>
                <b-tab title="Publication Filters">
                    <PublicationFiltersTab />
                </b-tab>
            </b-tabs>

            <template #modal-footer>
                <b-button variant="light" @click="close">
                    Close
                </b-button>
            </template>

        </b-modal>
    </div>
</template>

<style lang="scss" scoped>
.url,
.message {
    .copy-to-clipboard {
        visibility: hidden;
    }
    &:hover {
        .copy-to-clipboard {
            visibility: visible;
        }
    }
}
</style>

<script>
import { mapState } from 'vuex'
import PublicationFiltersTab from '@/components/modals/settings/PublicationFiltersTab'

export default {
    props: [
        'value'
    ],
    components: {
        PublicationFiltersTab,
    },
    computed: {
        ...mapState({
            wysiwygMenuType: state => state.settings.wysiwyg_menu_type,
            lexile_certified_score_editable: state => state.settings.lexile_certified_score_editable,
        }),
        modal_id () {
            let modal_id = 'settings-modal'
            return modal_id
        },
        wysiwyg_menu_type: {
            get () {
                return this.wysiwygMenuType
            },
            set (type) {
                this.$store.commit('setWYSIWYGMenuType', type)
            }
        },
        edit_lexile_certified_score: {
            get () {
                return this.lexile_certified_score_editable
            },
            set (editable) {
                this.$store.commit('setLexileCertifiedScoreEditable', editable)
            }
        },
    },
    methods: {
        close () {
            this.$emit('hide')
        },
        hidden () {
            this.$emit('hide')
        },
    },
}
</script>
